import type { PendingChangeRequestResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetPendingChangeRequestsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetPendingChangeRequestsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import { mapChangeRequestRowsToFragment } from './mapChangeRequestRowsToFragment';

type UseGetPendingChangeRequestsArgs = {
  parentId: string;
};

export const useGetPendingChangeRequests = createQueryHook<
  UseGetPendingChangeRequestsArgs,
  PendingChangeRequestResponseRow[],
  GetPendingChangeRequestsQuery
>({
  trpcQueryOptions: (trpc, { parentId }) =>
    trpc.frontend.changeRequest.pendingChangeRequests.queryOptions({
      parentId,
    }),
  mapTrpcDataToGraphQL: (trpcData) => ({
    change_request: mapChangeRequestRowsToFragment(trpcData),
  }),
  graphqlDocument: GetPendingChangeRequestsDocument,
  graphqlVariables: ({ parentId }) => ({ ParentId: parentId }),
  graphqlFetchPolicy: 'network-only',
});
